import { useGlobalState } from 'piral-core';
import * as React from 'react';

import './project-icon.css';

export const ProjectIcon: React.FC = () => {
  const { piletIconStorage } = useGlobalState();
  const baseRoute = window.location.pathname.split('/')[1] || '';

  const icon = piletIconStorage.getIcon(baseRoute);

  const isRootRoute = window.location.pathname === '/';
  if (isRootRoute) {
    return null;
  }

  return <div>{icon && <img src={icon} className="project-icon" alt="project icon" />}</div>;
};
